// extracted by mini-css-extract-plugin
export default {"modal":"MedalManagerPage_modal__GzYKY","medalsContainer":"MedalManagerPage_medalsContainer__HLdVk"};